import { cn } from "@/lib/utils";
import { BLOG_STATUS_CONFIG } from "@/lib/status-configs";
import type { BlogPost } from "@/types";

const STATUS_CONFIG = BLOG_STATUS_CONFIG;

export function PostStatusBadge({ status }: { status: BlogPost["status"] }) {
  const config = STATUS_CONFIG[status];
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1",
        config.bg,
        config.color,
        config.ring
      )}
    >
      <span className={cn("size-1.5 rounded-full", config.dot)} />
      {config.label}
    </span>
  );
}
